'use client';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Scroll.module.js';

function useHashFragment() {
    var location = useLocation();
    var lastHash = React.useRef("");
    // listen to location change using useEffect with location as dependency
    // https://jasonwatmore.com/react-router-v6-listen-to-location-route-change-without-history-listen
    React.useEffect(function () {
        if (location.hash) {
            lastHash.current = location.hash.slice(1); // safe hash for further use after navigation
        }
        if (lastHash.current && document.getElementById(lastHash.current)) {
            setTimeout(function () {
                var element = document.getElementById(lastHash.current);
                if (!element) {
                    return;
                }
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
                lastHash.current = "";
            }, 100);
        }
    }, [location]);
}
function useAutoPosition() {
    React.useEffect(function () {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
}
function useScrollPosition() {
    var _a = React.useState(0), scrollX = _a[0], setScrollX = _a[1];
    var _b = React.useState(0), scrollY = _b[0], setScrollY = _b[1];
    React.useEffect(function () {
        var handleScroll = function () {
            setScrollX(window.scrollX);
            setScrollY(window.scrollY);
        };
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return function () {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return {
        x: scrollX,
        y: scrollY
    };
}
function useScrollSpeed(props) {
    var _a = (props || {
        speedY: 1
    }).speedY, speedY = _a === void 0 ? 1 : _a;
    var factorY = speedY * 10;
    React.useEffect(function () {
        var handleWheel = function (e) {
            e.preventDefault();
            var top = window.scrollY + (e.deltaY * factorY);
            window.scrollTo({
                top: top,
                behavior: "smooth"
            });
        };
        document.addEventListener("wheel", handleWheel, { passive: false });
        return function () {
            document.removeEventListener("wheel", handleWheel);
        };
    }, [factorY]);
}
function useScrollStyle(props) {
    var _a = props.target, target = _a === void 0 ? "html" : _a, _b = props.x, x = _b === void 0 ? false : _b, _c = props.y, y = _c === void 0 ? false : _c;
    React.useEffect(function () {
        var element = document.querySelector(target);
        if (!element) {
            return;
        }
        if (!x && !y) {
            return;
        }
        var scrollbar = "";
        if (x && y) {
            scrollbar = styles["scrollbar-pretty"];
        }
        if (x) {
            scrollbar = styles["scrollbar-pretty-x"];
        }
        if (y) {
            scrollbar = styles["scrollbar-pretty-y"];
        }
        element.classList.add(scrollbar);
        return function () {
            element.classList.remove(scrollbar);
        };
    }, [x, y, target]);
}

export { useAutoPosition, useHashFragment, useScrollPosition, useScrollSpeed, useScrollStyle };
